import React from 'react';
import bem from 'utils/bem';
import Icon from 'components/Icon';

import './index.sass';

const { block } = bem('spinner');

const Spinner = () => {
    return (
        <div className={block()}>
            <Icon name='spinner' />
        </div>
    )
}

export default Spinner;
